<template>
    <sector-add-form></sector-add-form>
</template>


<script>

    import SectorAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            SectorAddForm,
        },

    }
</script>

